import { type Citation } from "../../../../models/audit/citation";
import { type ViewerBoundingBox } from "../../../extraction/viewExtraction/FileViewer";

/**
 * The doc-viewer bounding boxes for one document: every citation on `docId` that
 * carries a box, mapped to the viewer's box shape. Shared by the review path
 * (`useCitationActions`) and the Agent Steps path so the box derivation lives in
 * one place; callers that need callout colour/label/note decorate the result.
 */
export function citationsToViewerBoxes(
  citations: Citation[],
  docId: string | undefined,
): ViewerBoundingBox[] | undefined {
  if (!docId) return undefined;
  const boxes = citations
    .filter((c) => c.documentId === docId && !!c.boundingBox)
    .map((c) => ({
      id: c.id || undefined,
      boundingBox: c.boundingBox!,
      pageNumber: c.pageNumber || undefined,
      pageWidth: c.pageWidth || undefined,
      pageHeight: c.pageHeight || undefined,
    }));
  return boxes.length > 0 ? boxes : undefined;
}
